import React, { useEffect, useRef } from 'react'

const SelectiveCopy = ({ children }) => {
  const ref = useRef(null)

  useEffect(() => {
    const handleCopy = (e) => {
      const selection = window.getSelection()
      if (!selection || selection.rangeCount === 0) return

      const container = document.createElement('div')

      for (let i = 0; i < selection.rangeCount; i++) {
        const range = selection.getRangeAt(i)
        const clonedContents = range.cloneContents()

        // Remove elements with [data-nocopy]
        const removeNoCopy = (node) => {
          if (!node || !node.childNodes) return
          const toRemove = []
          node.childNodes.forEach((child) => {
            if (child.nodeType === Node.ELEMENT_NODE) {
              if (child.hasAttribute('data-nocopy')) {
                toRemove.push(child)
              } else {
                removeNoCopy(child)
              }
            } else {
              removeNoCopy(child)
            }
          })
          toRemove.forEach((n) => n.remove())
        }

        removeNoCopy(clonedContents)

        container.appendChild(clonedContents)
      }

      e.preventDefault()
      e.clipboardData?.setData('text/html', container.innerHTML)
      e.clipboardData?.setData('text/plain', container.innerText)
    }

    const node = ref.current
    if (node) {
      node.addEventListener('copy', handleCopy)
    }
    return () => {
      if (node) {
        node.removeEventListener('copy', handleCopy)
      }
    }
  }, [])

  return <div ref={ref}>{children}</div>
}

export default SelectiveCopy
